require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-to-implement-an-nsnotification-observer-in-swift.json") })
        }
      }, "path---blog-how-to-implement-an-nsnotification-observer-in-swift");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-to-implement-an-nsnotification-observer-in-swift!./.cache/json/blog-how-to-implement-an-nsnotification-observer-in-swift.json
// module id = 853
// module chunks = 231608221292675